let topDistance;
let windowHeight;
let menuHeight;
let menu = $('.right-wrapper')

$(window).on('resize',function(){
	windowHeight = window.innerHeight;
	topDistance = $('.sub-head').height();
	menuHeight = windowHeight - topDistance;
	menu.height(menuHeight)
})

$(window).trigger('resize')
